<template>
	<hsc-menu-item v-if="copyMenu != null" ref="copyParent">
			<!-- Item principale du menu -->
			<div slot="body">
				<b-img :src="AbsoluteLink('Icons/' + copyMenu.MainItem.Icon)" />&nbsp;&nbsp;{{ $t(copyMenu.MainItem.Text) }}
			</div>
			<!-- Item pour copier toutes les informations d'un coup -->
			<hsc-menu-item 
				:class="['border-bottom pt-2 pb-2', {['bg-' + Variant + '-light' + ' text-' + Variant]: copyMenu.CopyAllItem.Selected}]" 
				@click.native.stop
			>
				<div slot="body" v-if="copyMenu.CopyAllItem.Icon"  @click="copyAllInfo(copyMenu.CopyAllItem)" class="d-flex justify-content-between align-items-center">
					<span>{{copyMenu.CopyAllItem.Text}}</span>
					<b-img :src="AbsoluteLink('Icons/' + copyMenu.CopyAllItem.Icon)" class="ml-3" />
				</div>
			</hsc-menu-item>
			<!-- Item du sous-menu  -->
			<!-- On utilise stop pour pouvoir décider dans le script de la fermeture du menu-->
			<hsc-menu-item v-for="(item, index) in copyMenu.SubItems" 
				:key="index" :label="$t(item.Text)" 
				:class="['pt-1', {['bg-' + Variant + '-light' + ' text-' + Variant]: item.Selected}]"
				@click.native.stop
			>
				<div slot="body" 
					v-if="item.Visible"  
					@click="copyInfo(item)" 
					:class="['d-flex', 'justify-content-between', 'align-items-center']"
				>
					<span>{{item.Text}}</span>
					<b-img :src="AbsoluteLink('Icons/' + item.Icon )" class="ml-3" />
				</div>
			</hsc-menu-item>
	</hsc-menu-item>
</template>

<script lang="ts">
	import Component from 'vue-class-component';
	import { InjectReactive, Prop, PropSync } from "vue-property-decorator";
	import { LinkUtils } from "@/components/commons/Utils";
	import locales from '../locales/CopyMenu.json';
	import CopyInfoMenu from '@/types/CopyInfoMenu';
	import CopyInfoMenuItem from '@/types/CopyInfoMenuItem';

	/** Composant item de menu de filtre des sous-types */
	@Component({
		name: 'copy-data-menu-item',
		components: {
			CopyDataMenuItem
		},
		i18n:{messages: locales},
	})
	export default class CopyDataMenuItem extends LinkUtils {
		/** Items de menu */
		@PropSync("CopyMenu", { default : () => {} })
		public copyMenu!: CopyInfoMenu;

		/** Variant de couleurs à appliquer */
        @Prop()
        public Variant!:string;

		/** Nom de l'instance d'arborescence à utiliser */
		@InjectReactive()
		private sourceFilterTree!: string;

		/** Copie le texte dans le press papier */
		private copyToClipboard(data: string){
			navigator.clipboard.writeText(data);
		}

		/**
		 * On passe les items à l'état sélectionné et on change l'icone
		 * @param items 
		 * @params icons : icones de sélection
		 */
		private selectItems(items: CopyInfoMenuItem[], icons: string[]){
			for(let i = 0 ; i < items.length ; i++){
				items[i].Selected = true;
				items[i].Icon = icons[i];
			}
		}

		/**
		 * On passe les items à l'état desélectionné et on change l'icone
		 * @param items 
		 * @params icons : icones de desélection
		 */
		private unselectItems(items: CopyInfoMenuItem[], icons: string[]){
			for(let i = 0 ; i < items.length ; i++){
				items[i].Selected = false;
				items[i].Icon = icons[i];
			}
		}

		/**
		 * Copie de la valeur de l'item dans le presse papier + toast
		 * @param item 
		 */
		private async copyInfo(item: CopyInfoMenuItem) {
			let data: string = item.Value;

			let items : CopyInfoMenuItem[] = [item];
			let selectedIcons : string[] = ["check2-circle.svg"];
			let unselectedIcons : string[] = [item.Icon];

			this.handleCopyAndDisplay(data, items, selectedIcons, unselectedIcons);
		}

		private copyAllInfo(item: CopyInfoMenuItem){
			let data : string = item.Value;

			let items: CopyInfoMenuItem[] = new Array(this.copyMenu.SubItems.length + 1);
			let selectedIcons : string[] = new Array(this.copyMenu.SubItems.length + 1)
			let unselectedIcons : string[] = new Array(this.copyMenu.SubItems.length + 1)

			for(let i = 0 ; i < this.copyMenu.SubItems.length ; i++){
				items[i] = this.copyMenu.SubItems[i];
				unselectedIcons[i] = items[i].Icon;
				selectedIcons[i] = "check2-circle.svg";
			}

			items[this.copyMenu.SubItems.length] = item;
			unselectedIcons[this.copyMenu.SubItems.length] = item.Icon;
			selectedIcons[this.copyMenu.SubItems.length] = "check2-circle.svg";

			this.handleCopyAndDisplay(data, items, selectedIcons, unselectedIcons);
		}

		/**
		 * Copie la donnée dans le presse papier et gère l'affichage des items du menu (sélection puis déselection)
		 * @param data 
		 * @param items 
		 * @param unselectedIcons
		 * @param selectedIcons 
		 */
		private handleCopyAndDisplay(data: string, items: CopyInfoMenuItem[], selectedIcons: string[], unselectedIcons: string[]){
			this.copyToClipboard(data);

			this.selectItems(items, selectedIcons);

			setTimeout(
				() => {
					this.closeMenu();
					this.unselectItems(items, unselectedIcons);
				}
				,2000 
			);

			this.displayToast();
		}


		private displayToast(){
			this.$bvToast.toast(this.$t('CopyInClipboard').toString(), {
				title: this.$t('DataCopied').toString(),
				autoHideDelay: 3000,
				variant: "info",
				solid: true,
				appendToast: true,
				toaster: "b-toaster-top-center"
			});
		}

		private closeMenu(){
			const component = this.$refs.copyParent as any;

			if (component && component.$el) {
				const element = component.$el as HTMLElement;
				element.click();
			}
		}
	}
</script>